import React from "react";
import { useSearchParams } from "react-router-dom";
import ProjectFormHeading from "./layouts/heading";

import { Switch, Case } from "@/components/switch";
import ProjectOrganisationContextProvider from "./context/project-organisation/project-organisation-context-provider.tsx";
import ProjectOrganisationLayout from "./layouts/organisation/layouts";
import ProjectFormNavigationProvider from "./context/project-form-navigation/project-form-navigation-provider.tsx";
import ProjectMeasuresLayout from "./layouts/measures/layouts";
import ValidationLayout from "./layouts/validation/layouts";
import { ProjectFormPageKey } from "./context/project-form-navigation/project-form-navigation-context-props.ts";
import TakeOffProcesses from "./layouts/processes/layouts";
import ProjectHeadingProvider from "./context/project-heading/project-heading-provider.tsx";
import ProjectOverlayLayout from "./layouts/overlay/layouts/index.tsx";
import ProjectCopyLayout from "./layouts/copy/layouts/index.tsx";
import ExtractionLayout from "./layouts/extraction/layouts/index.tsx";
import ProjectMeasureProvider from "@/pages/takeoff/context/project-measure/project-measure-provider.tsx";
import ProjectIndicatorsProvider from "./context/project-indicators/project-indicators-provider.tsx";
import ProjectLockDialogShowerProvider
    from "@/pages/takeoff/context/project-lock-dialog-shower/project-lock-dialog-shower-provider.tsx";
import ValidationProvider from "./layouts/validation/context/validation/validation-provider.tsx";

const ProjectForm: React.FC = () => {
    const [searchParams] = useSearchParams();
    const route = (searchParams.get('tab') as ProjectFormPageKey) || 'measures';

    return (
        <div className="flex flex-col flex-1 overflow-hidden bg-white divide-y divide-gray-100 h-full">
            <ProjectFormHeading />

            <div className='flex flex-1 flex-row overflow-y-auto'>
                <Switch value={route}>
                    <Case value={"organisation"}>
                        <ProjectOrganisationLayout />
                    </Case>

                    <Case value={"overlay"}>
                        <ProjectOverlayLayout />
                    </Case>

                    <Case value={"measures"}>
                        <ProjectMeasureProvider>
                            <ProjectMeasuresLayout />
                        </ProjectMeasureProvider>
                    </Case>
                    
                    <Case value={"extraction"}>
                        <ProjectMeasureProvider>
                            <ExtractionLayout />
                        </ProjectMeasureProvider>
                    </Case>

                    <Case value={"copy"}>
                        <ProjectCopyLayout />
                    </Case>

                    <Case value={"validation"}>
                        <ValidationLayout />
                    </Case>

                    <Case value={"processes"}>
                        <TakeOffProcesses />
                    </Case>
                </Switch>
            </div>
        </div>
    )
};

const TakeOffPage: React.FC = () => (
    <ProjectFormNavigationProvider>
        <ProjectHeadingProvider>
            <ProjectIndicatorsProvider>
                <ProjectOrganisationContextProvider>
                    <ProjectLockDialogShowerProvider>
                        <ValidationProvider>
                            <ProjectForm/>
                        </ValidationProvider>
                    </ProjectLockDialogShowerProvider>
                </ProjectOrganisationContextProvider>
            </ProjectIndicatorsProvider>
        </ProjectHeadingProvider>
    </ProjectFormNavigationProvider>
);

export default TakeOffPage;